// Product prices are party totals, not per-guest rates: a "for Two" package is £198 for
// the pair, and its one-guest sibling is a separate £99 product. AvailabilityService,
// ProductSearchService's `price_from` and the basket line all carry that total, so every
// "per person" figure on screen is derived - here, once, for both booking panels and the
// search card.
//
// PHP twin: App\Support\PerPersonPrice, which serves the server-rendered product page.
// Keep the two in step - neither can call the other.
//
// Null for an unknown total, so callers can withhold the row rather than print £0/£NaN.
export function perPersonPrice(total, people) {
    if (total === null || total === undefined || total === '') {
        return null;
    }

    // JSON can carry a price as a string ("198.00"), same as formatPrice() allows.
    const value = Number(total);

    if (Number.isNaN(value)) {
        return null;
    }

    const guests = Number(people);

    // Below 1, or absent as a treatment's is, leaves nothing to divide by.
    return Number.isFinite(guests) && guests >= 1 ? value / guests : value;
}
